import {CommonButtonLabel, FastRobotErrorcode, Feedback, ViewMode} from 'constants/dataEnum';
import {parseMessage} from 'lib/stringHelper';
import {showModalSimplified} from 'stores/business/commonModalBusiness';
import {changeView, showSnackbar} from 'stores/actions/appStateAction';
import {fastCommonActuatorAPIErrorHandler} from 'stores/business/errorHandlerBusiness';
import {showModalTrayIdPositionNotFoundSetupWizard} from 'stores/business/modalStateBusinessAction';
import {showLoadCellErrorModal} from 'stores/business/loadCellErrorBusiness';
import {setErrorCodeNumber} from 'stores/business/commonBusiness';
import {fastRecovery} from 'stores/business/recoveryBusiness';

export const showTipsPickupCalibrationAbortedToast = () => (dispatch) => {
  dispatch(showSnackbar(Feedback.ERROR, parseMessage('tipsPickupCalibration.toast.aborted')));
};

const failedCallback = () => async (dispatch) => {
  await dispatch(fastRecovery());
  dispatch(showTipsPickupCalibrationAbortedToast());
};

const GeneralErrorButton =
  (successCallback = () => {}) =>
  (dispatch) => [
    {
      label: parseMessage(CommonButtonLabel.RETRY),
      onClick: successCallback,
    },
    {
      label: parseMessage(CommonButtonLabel.ABORT),
      onClick: () => dispatch(failedCallback()),
    },
  ];

const showCalibrationValueTooHighModal = (successCallback) => (dispatch) => {
  const title = parseMessage('tipsPickupCalibration.modal.calibrationValueTooHigh.title');
  const text = parseMessage('tipsPickupCalibration.modal.calibrationValueTooHigh.text');

  dispatch(showModalSimplified(title, text, dispatch(GeneralErrorButton(successCallback))));
};

const showCollisionTriggeredModal = (successCallback) => (dispatch) => {
  const title = parseMessage('tipsPickupCalibration.modal.collisionDetectionTriggered.title');
  const text = parseMessage('tipsPickupCalibration.modal.collisionDetectionTriggered.text');

  dispatch(showModalSimplified(title, text, dispatch(GeneralErrorButton(successCallback))));
};

const showAbnormalCalibrationModal = (successCallback) => (dispatch) => {
  const title = parseMessage('tipsPickupCalibration.modal.abnormalCalibration.title');
  const text = parseMessage('tipsPickupCalibration.modal.abnormalCalibration.text');

  dispatch(showModalSimplified(title, text, dispatch(GeneralErrorButton(successCallback))));
};

const showCalibrationToolNotFoundModal = (successCallback) => (dispatch) => {
  const title = parseMessage('tipsPickupCalibration.modal.calibrationToolNotFound.title');
  const text = parseMessage('tipsPickupCalibration.modal.calibrationToolNotFound.text');

  dispatch(showModalSimplified(title, text, dispatch(GeneralErrorButton(successCallback))));
};

// eslint-disable-next-line import/prefer-default-export
export const tipsPickupCalibrationErrorHandler = (error, successCallback) => async (dispatch) => {
  await dispatch(setErrorCodeNumber(error));

  switch (error) {
    case FastRobotErrorcode.INVALID_VERTICAL_TRIGGERED_POSITION:
      dispatch(showCalibrationValueTooHighModal(successCallback));
      return;
    case FastRobotErrorcode.UNWANTED_COLLISION_TRIGGERED:
    case FastRobotErrorcode.COLLISION_TRIGGERED_IN_FIRST_SEQUENCE:
      dispatch(showCollisionTriggeredModal(successCallback));
      return;
    case FastRobotErrorcode.MAX_TUNING_SEQUENCE_COUNT:
      dispatch(showAbnormalCalibrationModal(successCallback));
      return;
    case FastRobotErrorcode.CADDY_JIG_SURFACE_NOT_DETECTED:
      dispatch(showCalibrationToolNotFoundModal(successCallback));
      break;
    case FastRobotErrorcode.TRAY_ID_POSITION_NOT_FOUND:
      dispatch(showModalTrayIdPositionNotFoundSetupWizard(successCallback, true));
      break;
    case FastRobotErrorcode.LOAD_CELL_VALUE_NO_CHANGE:
    case FastRobotErrorcode.LOAD_CELL_DRIVER_FAULT:
    case FastRobotErrorcode.LOAD_CELL_READ_TIMEOUT:
      dispatch(showLoadCellErrorModal(() => dispatch(changeView(ViewMode.EXPLORER)), error, successCallback));
      break;
    default: {
      dispatch(fastCommonActuatorAPIErrorHandler(error, successCallback, failedCallback));
    }
  }
};
